
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injectable, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './View/authentication/login/login.component';
import { SignupComponent } from './View/authentication/signup/signup.component';

import { HttpClientModule, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfileComponent } from './View/popup/profile/profile.component';
import { PublicComponent } from './View/public/public.component';


import { HeaderComponent } from './_Shared/header/header.component';
import { FooterComponent } from './_Shared/footer/footer.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatCarouselModule } from '@ngmodule/material-carousel';
import { goonComponent } from './View/goon/goon.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ForgetPasswordComponent } from './View/authentication/forget-password/forget-password.component';
import { ToastrModule } from 'ngx-toastr';

import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { DateAdapter, MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatRadioModule } from '@angular/material/radio';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HomeComponent } from './Home/home/home.component';

import { NumberonlyDirective, numberMobileNoDirective } from './_common/_directives/numberonly.directive';
import { AuthGuard } from './_common/_authguards/AuthGuard';

import { KycComponent } from './View/popup/kyc/kyc.component';
import { OtpverificationComponent } from './View/popup/otpverification/otpverification.component';
import { ChangePasswordComponent } from './View/popup/change-password/change-password.component';
import { MerchantloginComponent } from './View/authentication/merchantlogin/merchantlogin.component';
import { CommonService, CommonService1, CommonService2, CartService } from './_common/_service/user.service';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AuthenticationService } from './_common/_service/authentication.service';
import { EncrDecrService, ParameterHashLocationStrategy } from './_common/_service/EncrDecrService.service';
import { MobilemoneyComponent } from './View/service/mobilemoney/mobilemoney.component';
import { ConfirmDialogComponent } from './View/popup/confirm-dialog/confirm-dialog.component';
import { PaymentConfirmDialogComponent } from './View/popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { AuthInterceptor } from './_common/_interceptor/auth.interceptor';

import { EmailDialogComponent } from './View/popup/email-dialog/email-dialog.component';
import { InternationalMobileRechargeComponent } from './View/service/international-recharge/international-mobile-recharge.component';
import { InternationalDTHServicesComponent } from './View/service/international-dthservices/international-dthservices.component';


import { FaqComponent } from './_Shared/static/faq/faq.component';
import { TermsAndConditionComponent } from './_Shared/static/terms-and-condition/terms-and-condition.component';
import { PrivacyPolicyComponent } from './_Shared/static/privacy-policy/privacy-policy.component';
import { HowitWorksComponent } from './_Shared/static/howit-works/howit-works.component';
import { RefundsComponent } from './_Shared/static/refunds/refunds.component';
import { ChargebackComponent } from './_Shared/static/chargeback/chargeback.component';

import { ContactusComponent } from './_Shared/static/contactus/contactus.component';
import { AboutUsComponent } from './_Shared/static/about-us/about-us.component';
import { MatExpansionModule } from '@angular/material/expansion'; 
import { userorderdetailComponent } from './View/service/userorderdetail/userorderdetail.component';
import { DatePipe } from '@angular/common';

import { BanktransferComponent } from './View/service/banktransfer/banktransfer.component';    

import { NotificationwebComponent } from './View/popup/notificationweb/notificationweb.component';
import { Platform } from '@angular/cdk/platform';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { ShowCodeComponent } from './View/wallet-service/show-code/show-code.component';
import { ViewPaymentRequestComponent } from './View/wallet-service/view-payment-request/view-payment-request.component';
import { PayMoneyComponent } from './View/wallet-service/pay-money/pay-money.component';
import { MakePaymentRequestComponent } from './View/wallet-service/make-payment-request/make-payment-request.component';
import { GiftVoucherComponent } from './View/wallet-service/GiftVoucher/GiftVoucher.component';


import { CarouselModule } from 'ngx-owl-carousel-o';
import { AddcardComponent } from './View/popup/add-card/add-card.component';
import { OpenchangepasswordComponent } from './View/popup/openchangepassword/openchangepassword.component';
import { ConfirmPasswordDialogComponent } from './View/popup/confirm-password-dialog/confirm-password-dialog.component';
import { InvoiceDetailComponent } from './View/popup/InvoiceDetail/InvoiceDetail.component';

import { MerchantdocDialogComponent } from './View/popup/merchantdoc/merchantdoc.component';
import { EditIdMobilemoneybeneficiariComponent } from './View/service/editIdmobilemoneybeneficiari/editIdmobilemoneybeneficiari.component';
import { BeforePaymentConfirmDialogComponent } from './View/popup/beforepayment-confirm-dialog/beforepayment-confirm-dialog.component';
import { VoucherresponseComponent } from './View/Voucher/Voucherresponse.component';
import { FlutterBankresponseComponent } from './View/Flutterbankresponse/Flutterbankresponse.component';
import { ConfirmNGNDialogComponent } from './View/popup/confirm-ngn-dialog/confirm-ngn-dialog.component';
import { BeneficiaryMobilemoneyComponent } from './View/service/beneficiarymobilemoney/beneficiarymobilemoney.component';
import { ConfirmmobilemoneDialogComponent } from './View/popup/confirm-mobilemone-dialog/confirm-mobilemone-dialog.component';
import { BeneficiaryBanktransferComponent } from './View/service/beneficiarybanktransfer/beneficiarybanktransfer.component';
import { ConfirmbanktransferDialogComponent } from './View/popup/confirm-banktransfer-dialog/confirm-banktransfer-dialog.component';
import { EditIdbanktransferbeneficiariComponent } from './View/service/editIdbanktransferbeneficiari/editIdbanktransferbeneficiari.component';
import { PluginaddComponent } from './View/wallet-service/pluginadd/pluginadd.component';
import { MerchantapiComponent } from './View/popup/merchantapi/merchantapi.component';
import { AddmerchantstoreComponent } from './View/popup/add-merchantstore/add-merchantstore.component';
import { AddmerchantstorelistComponent } from './View/popup/add-merchantstorelist/add-merchantstorelist.component';
import { VerificationDirective } from './_common/_directives/verification.directive';
import { CookieService } from 'ngx-cookie-service';
import { UpdatereferencialCodeComponent } from './View/popup/updatereferencialCode/updatereferencialCode.component';
import { NigeriausdbanktransferBeneficiaryComponent } from './View/service/nigeriausdbanktransfer-beneficiary/nigeriausdbanktransfer-beneficiary.component';
import { NigeriausdbanktransferComponent } from './View/service/nigeriausdbanktransfer/nigeriausdbanktransfer.component';
import { KoraBankresponseComponent } from './View/KoraBankresponse/KoraBankresponse.component';
import { KorapaybanktransfernigeriaComponent } from './View/service/korapaybanktransfernigeria/korapaybanktransfernigeria.component';
import { KorapaybanktransfernigeriaBeneficiaryComponent } from './View/service/korapaybanktransfernigeria-beneficiary/korapaybanktransfernigeria-beneficiary.component';
import { cartComponent } from './View/service/cart/cart.component';
import { CourseContentComponent } from './View/service/CourseContent/CourseContent.component';
import { PromoListComponent } from './View/service/PromoList/PromoList.component';
import { PaymentSuccessComponent } from './View/service/payment-success/payment-success.component';


const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#326395',
  // bgsOpacity: 0.5,
  // bgsPosition: POSITION.bottomCenter,
  // bgsSize: 60,
  // bgsType: SPINNER.rectangleBounce,
  fgsColor: '#326395',
  // fgsPosition: POSITION.centerCenter,
  // fgsSize: 60,
  // fgsType: SPINNER.chasingDots,
  // logoUrl: 'assets/angular.png',
  pbColor: '#326395',
  // pbDirection: PB_DIRECTION.leftToRight,
  // pbThickness: 5,
  // text: 'Welcome to ngx-ui-loader',
  // textColor: '#FFFFFF',
  // textPosition: POSITION.centerCenter
};


// Our service to handle errors (ideally in its own file)
@Injectable()
export class ErrorLogService {
  private name: String = 'ErrorLogService';

  logError(error: any) {
    if (error instanceof HttpErrorResponse) {
      console.error('There was an HTTP error.', error.message, 'Status code:', (<HttpErrorResponse>error).status);
    } else if (error instanceof TypeError) {
      console.error('There was a Type error.', error.message);
    } else if (error instanceof Error) {
      console.error('There was a general error.', error.message);
    } else {
      console.error('Nobody threw an error but something happened!', error);
    }
  }
}

// global error handler that utilizes the above created service (ideally in its own file)

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private errorLogService: ErrorLogService) {
    super();
  }

  handleError(error: any) {
    this.errorLogService.logError(error);
  }
}


@NgModule({
  declarations: [

    userorderdetailComponent, ChargebackComponent, FaqComponent, HowitWorksComponent, PrivacyPolicyComponent,
    RefundsComponent, TermsAndConditionComponent, AboutUsComponent, ContactusComponent,
    AppComponent, HomeComponent, LoginComponent, SignupComponent, ProfileComponent, PublicComponent, HeaderComponent,
    FooterComponent, goonComponent, ForgetPasswordComponent,
    NumberonlyDirective, numberMobileNoDirective, KycComponent, OtpverificationComponent, ChangePasswordComponent,
    MerchantloginComponent, MobilemoneyComponent,
    ConfirmDialogComponent, PaymentConfirmDialogComponent,  EmailDialogComponent,
    InternationalMobileRechargeComponent,    InternationalDTHServicesComponent,    
    BanktransferComponent, PromoListComponent, NotificationwebComponent,
    ShowCodeComponent, ViewPaymentRequestComponent, PayMoneyComponent, MakePaymentRequestComponent, GiftVoucherComponent,
    PluginaddComponent, cartComponent, AddcardComponent, OpenchangepasswordComponent,
    ConfirmPasswordDialogComponent, InvoiceDetailComponent, CourseContentComponent, MerchantdocDialogComponent, EditIdMobilemoneybeneficiariComponent,
    BeforePaymentConfirmDialogComponent, VoucherresponseComponent, FlutterBankresponseComponent, ConfirmNGNDialogComponent,
    BeneficiaryMobilemoneyComponent, ConfirmmobilemoneDialogComponent, BeneficiaryBanktransferComponent, ConfirmbanktransferDialogComponent,
    EditIdbanktransferbeneficiariComponent,
    MerchantapiComponent, AddmerchantstoreComponent, AddmerchantstorelistComponent, UpdatereferencialCodeComponent,
    VerificationDirective, NigeriausdbanktransferBeneficiaryComponent, NigeriausdbanktransferComponent, KoraBankresponseComponent,
    KorapaybanktransfernigeriaComponent, KorapaybanktransfernigeriaBeneficiaryComponent, PaymentSuccessComponent

  ],
  imports: [
    
    CarouselModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    MatExpansionModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    BrowserAnimationsModule, MatDialogModule,
    MatFormFieldModule,    
    MatButtonModule,
    ToastrModule.forRoot(),
    ReactiveFormsModule,
    MatSelectModule,    
    FormsModule,
    ReactiveFormsModule,
    
    BrowserAnimationsModule,
    MatButtonModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatRadioModule,
    MatCardModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatToolbarModule,
    AppRoutingModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    CdkTableModule,
    MatCarouselModule,

    MatPaginatorModule

  ],
  entryComponents: [
    OtpverificationComponent, KycComponent, ConfirmDialogComponent, PaymentConfirmDialogComponent,
     EmailDialogComponent, NotificationwebComponent, AddcardComponent,
    OpenchangepasswordComponent, ConfirmPasswordDialogComponent, InvoiceDetailComponent, MerchantdocDialogComponent,
    BeforePaymentConfirmDialogComponent, ConfirmNGNDialogComponent, ConfirmmobilemoneDialogComponent, BeneficiaryBanktransferComponent,
    ConfirmbanktransferDialogComponent, MerchantapiComponent, AddmerchantstoreComponent, AddmerchantstorelistComponent
  ],
  providers: [DatePipe, AuthGuard, CommonService, AuthenticationService, EncrDecrService, CommonService1, CommonService2, CartService,
   
    CookieService,
    // { provide: LocationStrategy, useClass: ParameterHashLocationStrategy },  
      
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // register global error handler
    GlobalErrorHandler,
    // register global error log service
    ErrorLogService
  ],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
